import { useState } from "react";

const DownloadImages: React.FunctionComponent<{ imageValue: any }> = (props) => {

    const [isDownload, setIsDownload] = useState<boolean>(false);

    const downloadImage = async (url: string, ext: string, filename: string) => {
        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error('Error downloading image');

            const blob = await response.blob();
            const objectUrl = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = objectUrl;
            a.download = filename.endsWith(`.${ext}`) ? filename : `${filename}.${ext}`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(objectUrl);
        } catch (error) {
            console.error('Error downloading image:', error);
        }finally{
            setIsDownload(false);
        }

    };


    const handleDownloadImage = () => {
        setIsDownload(true);
        downloadImage(props.imageValue, 'webp', `QR-Code`);
        setTimeout(() => {
            setIsDownload(false);
        }, props.imageValue.length * 500 + 500);
    };



    return (

        <button className="button-reset back-746AFF color-FFFFFF width-auto border-746AFF padd-15" onClick={handleDownloadImage}>
            <svg width="15" height="14" className="marg-right-5" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_606_5399)">
                    <path d="M11.7109 14.0273H3.28906C2.54962 14.0265 1.84072 13.7323 1.31786 13.2095C0.794994 12.6866 0.500868 11.9777 0.5 11.2383V2.81641C0.500868 2.07697 0.794994 1.36806 1.31786 0.8452C1.84072 0.322338 2.54962 0.0282121 3.28906 0.0273438H11.7109C12.4504 0.0282121 13.1593 0.322338 13.6821 0.8452C14.205 1.36806 14.4991 2.07697 14.5 2.81641V11.2383C14.4991 11.9777 14.205 12.6866 13.6821 13.2095C13.1593 13.7323 12.4504 14.0265 11.7109 14.0273ZM3.28906 1.12109C2.83959 1.1216 2.40868 1.30038 2.09086 1.6182C1.77303 1.93602 1.59426 2.36694 1.59375 2.81641V11.2383C1.59426 11.6878 1.77303 12.1187 2.09086 12.4365C2.40868 12.7543 2.83959 12.9331 3.28906 12.9336H11.7109C12.1604 12.9331 12.5913 12.7543 12.9091 12.4365C13.227 12.1187 13.4057 11.6878 13.4062 11.2383V2.81641C13.4057 2.36694 13.227 1.93602 12.9091 1.6182C12.5913 1.30038 12.1604 1.1216 11.7109 1.12109H3.28906Z" fill="white" />
                    <path d="M7.5 8.89625C7.35496 8.89625 7.21586 8.83863 7.1133 8.73607C7.01074 8.63352 6.95312 8.49442 6.95312 8.34937V3.26563C6.95312 3.12058 7.01074 2.98148 7.1133 2.87893C7.21586 2.77637 7.35496 2.71875 7.5 2.71875C7.64504 2.71875 7.78414 2.77637 7.8867 2.87893C7.98926 2.98148 8.04688 3.12058 8.04688 3.26563V8.34937C8.04688 8.49442 7.98926 8.63352 7.8867 8.73607C7.78414 8.83863 7.64504 8.89625 7.5 8.89625Z" fill="white" />
                    <path d="M7.49996 9.28661C7.37856 9.28698 7.2583 9.26327 7.14612 9.21685C7.03395 9.17043 6.93209 9.10223 6.84645 9.01619L4.72566 6.89568C4.62308 6.7931 4.56546 6.65397 4.56546 6.5089C4.56546 6.36383 4.62308 6.2247 4.72566 6.12212C4.82824 6.01954 4.96737 5.96191 5.11244 5.96191C5.25751 5.96191 5.39664 6.01954 5.49922 6.12212L7.49996 8.12314L9.5007 6.12212C9.60328 6.01954 9.74241 5.96191 9.88748 5.96191C10.0326 5.96191 10.1717 6.01954 10.2743 6.12212C10.3768 6.2247 10.4345 6.36383 10.4345 6.5089C10.4345 6.65397 10.3768 6.7931 10.2743 6.89568L8.15348 9.01619C8.06783 9.10223 7.96598 9.17043 7.8538 9.21685C7.74163 9.26327 7.62136 9.28698 7.49996 9.28661ZM9.88762 11.2811H5.1123C4.96726 11.2811 4.82816 11.2235 4.72561 11.1209C4.62305 11.0183 4.56543 10.8792 4.56543 10.7342C4.56543 10.5892 4.62305 10.4501 4.72561 10.3475C4.82816 10.2449 4.96726 10.1873 5.1123 10.1873H9.88762C10.0327 10.1873 10.1718 10.2449 10.2743 10.3475C10.3769 10.4501 10.4345 10.5892 10.4345 10.7342C10.4345 10.8792 10.3769 11.0183 10.2743 11.1209C10.1718 11.2235 10.0327 11.2811 9.88762 11.2811Z" fill="white" />
                </g>
                <defs>
                    <clipPath id="clip0_606_5399">
                        <rect width="14" height="14" fill="white" transform="translate(0.5)" />
                    </clipPath>
                </defs>
            </svg>
            Download  {isDownload && <div className="col-auto marg-left-5">
                <div className="spinner-border text-white" style={{ width: "20px", height: "20px" }} role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>}
        </button>
    )
}

export default DownloadImages;